"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FBDMenuSelectOptionWithValues = void 0;
const FBDMenuSelectOption_1 = require("./FBDMenuSelectOption");
class FBDMenuSelectOptionWithValues extends FBDMenuSelectOption_1.FBDMenuSelectOption {
    constructor(prefix, values, valueObjects, descriptions, callback = null, idx = 0) {
        if (valueObjects.length != values.length) {
            throw "Value objects length does not equal values length!";
        }
        super(prefix, values, descriptions, (idx) => {
            this.selected_object = valueObjects[idx];
            if (callback) {
                callback(this.selected_object);
            }
        }, idx);
        this.valueObjects = valueObjects;
        this.selected_object = valueObjects[idx];
    }
    setToValue(value) {
        const idx = this.valueObjects.indexOf(value);
        if (idx > 0) {
            this.setSelectedIdx(idx);
        }
        else {
            console.log("Couldn't not set to value " + value + ". Not found in value array.");
        }
    }
}
exports.FBDMenuSelectOptionWithValues = FBDMenuSelectOptionWithValues;
